import { useCallback } from 'react';
import { geocodeApi } from '@vmos2/core';
import { parseGeoCodeApiResponse } from './utils';

export const useGeocodeApi = (geoCodeSetting, geolocationKey) => {
  const searchAddress = useCallback(
    async searchText => {
      const addressesList = await geocodeApi.get(null, {
        params: {
          api_key: geolocationKey,
          text: searchText.trim(),
          'boundary.country': geoCodeSetting?.limitCountries,
          'focus.point.lat': geoCodeSetting?.latitude,
          'focus.point.lon': geoCodeSetting?.longitude,
        },
      });
      return parseGeoCodeApiResponse(addressesList);
    },
    [geolocationKey, geoCodeSetting]
  );

  return { searchAddress };
};
